import { ROUTES } from '../constants';
import { getLocal, setLocal } from '../local';
export default {
  methods: {
    setLocal(key, val) {
      setLocal(key, val);
    },
    getLocal(key, val) {
      return getLocal(key, val);
    },
    getCampaignIdeasLink(id) {
      return ROUTES.CAMPAIGN_IDEAS.PATH.replace(':id', id);
    }
  }
};
